import { JobStatusResponseStatusEnum } from '@src/api/generated/credit-api'
import { EXTERNAL_LINKS } from '@src/consts'
import { useFetchAccountConnectionStatus } from '@src/hooks/queries/accounts/fetchers'
import { isPresident } from '@src/utils/brand'

export const useUpsiderCredit = () => {
  const fetchJobsStatus = useFetchAccountConnectionStatus()

  const rawJobStatus = fetchJobsStatus?.data?.data

  const creditApiJobStatus =
    rawJobStatus?.status || JobStatusResponseStatusEnum.notConnected

  const showUpsiderCreditBadge =
    creditApiJobStatus === JobStatusResponseStatusEnum.expiring ||
    creditApiJobStatus === JobStatusResponseStatusEnum.expired ||
    creditApiJobStatus === JobStatusResponseStatusEnum.failure

  const brandPath = isPresident() ? 'president-card' : 'upsider-card'
  const linkToUpsiderCredit = `${EXTERNAL_LINKS.UPSIDER_CREDIT.LINK}/${brandPath}/bank/sign-in`

  const linkToUpsiderCreditHelp = isPresident()
    ? EXTERNAL_LINKS.PRESIDENT.SUPPORT.UPSIDER_CREDIT.LINK
    : EXTERNAL_LINKS.SUPPORT.UPSIDER_CREDIT.LINK

  return {
    creditApiJobStatus,
    showUpsiderCreditBadge,
    linkToUpsiderCredit,
    linkToUpsiderCreditHelp,
  }
}
